
import app from "../core/application";

type methodType = "GET" | "POST" | "PUT" | "DELETE";

async function sendRequest<TResponse>(url: string, method: methodType, data?: any): Promise<TResponse | null> {

    const application = app();

    const headers: Headers = new Headers();
    headers.append("content-type", "application/json; charset=utf-8");

    if (application.userSession) {
        headers.append("Authorization", `token ${application.userSession.authenticationToken}`)
    }

    let responsePayload: TResponse | null = null;
    const response = await fetch(application.webServiceBaseURL + url,
        {
            body: JSON.stringify(data),
            cache: "no-cache",
            headers,
            method,
            credentials: "include"
        }
    );

    if (response.ok) {
        responsePayload = await response.json();
    }

    // TODO: Handle token rotation
    // TODO: Handle errors

    return responsePayload;
}

export {sendRequest};
export default sendRequest;



// WEBPACK FOOTER //
// ./src/helpers/ajax.ts